import { render, staticRenderFns } from "./throttling.vue?vue&type=template&id=4a22bd15&"
import script from "./throttling.vue?vue&type=script&lang=js&"
export * from "./throttling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports